__turbopack_context__.v({
  "projectGrid": "page-module__khgPNq__projectGrid",
  "userMenu": "page-module__khgPNq__userMenu",
});
